import { useDispatch } from 'react-redux';
import { useForm } from '../../hooks/useForm';
import logo from '../../patio.svg';
import { startLogin } from '../../actions/auth/auth';

export const LoginScreen = () => {
    const dispatch = useDispatch();

    const [formLoginValues,,handleLoginInputChange] = useForm({
        email:'',
        password:''
    });

    const { email, password } = formLoginValues;

    const handleLogin=(e)=>{
        e.preventDefault();
        dispatch( startLogin(email, password) );
    }

    return (
        <div className="form-bg background_color">
            <div className="container container_login">
                    <div className="col-lg-offset-3 col-lg-6 col-md-offset-2 col-md-8">
                        <div className="form-container">
                            <div className="form-icon">
                                <img src={logo} className="my-3" alt="Patio logo" style={{"height":"60px"}} />
                            </div>
                            <form className="form-horizontal" onSubmit={handleLogin}>
                                <h3 className="title">Login</h3>
                                <div className="form-group">
                                    <span className="input-icon"><i className="fa fa-envelope"></i></span>
                                    <input 
                                        className="form-control" 
                                        type="email" 
                                        placeholder="Email Address"
                                        value={email}
                                        onChange={handleLoginInputChange}
                                        name="email"
                                    />
                                </div>
                                <div className="form-group">
                                    <span className="input-icon"><i className="fa fa-lock"></i></span>
                                    <input 
                                        className="form-control" 
                                        type="password" 
                                        placeholder="Password"
                                        value={password}
                                        onChange={handleLoginInputChange}
                                        name="password"
                                    />
                                </div>
                                <button className="btn signin">Login</button>
                            </form>
                        </div>
                    </div>
            </div>
        </div>
    )
}
